/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ group: NonNullable<unknown>, minimum: NonNullable<unknown> }} Task_Complete_Requirement_Group_RequiredInputs */

const en_task_complete_requirement_group_required = /** @type {(inputs: Task_Complete_Requirement_Group_RequiredInputs) => LocalizedString} */ (i) => {
	if ((i?.minimum === 1 || i?.minimum === "1")) return /** @type {LocalizedString} */ (`Select at least one checklist item in "${i?.group}".`);
	return /** @type {LocalizedString} */ (`Select at least ${i?.minimum} checklist items in "${i?.group}".`)
	
};

const pt_br2_task_complete_requirement_group_required = /** @type {(inputs: Task_Complete_Requirement_Group_RequiredInputs) => LocalizedString} */ (i) => {
	if ((i?.minimum === 1 || i?.minimum === "1")) return /** @type {LocalizedString} */ (`Marque pelo menos um item do checklist em "${i?.group}".`);
	return /** @type {LocalizedString} */ (`Marque pelo menos ${i?.minimum} itens do checklist em "${i?.group}".`)
	
};

/**
* | minimum | output |
* | --- | --- |
* | "1" | "Select at least one checklist item in \"{group}\"." |
* | * | "Select at least {minimum} checklist items in \"{group}\"." |
*
* @param {Task_Complete_Requirement_Group_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_requirement_group_required = /** @type {((inputs: Task_Complete_Requirement_Group_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Requirement_Group_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_requirement_group_required(inputs)
	return pt_br2_task_complete_requirement_group_required(inputs)
});